/**
 * Поведение гармошки моделей при клике.
 *
 * Раньше клик только выбирал модель, и открытый раздел «Дрейфы» нельзя было
 * свернуть — его настройки занимали панель целиком (фидбек владельца
 * 2026-08-07). Теперь клик по УЖЕ открытому разделу сворачивает его, не меняя
 * выбранную модель: слой на карте остаётся, прячутся только настройки.
 */
export function nextAccordion<T>(
  active: T,
  collapsed: boolean,
  clicked: T,
): { active: T; collapsed: boolean } {
  // Другой раздел — выбираем его и обязательно раскрываем: иначе клик выглядел
  // бы как «ничего не произошло».
  if (clicked !== active) return { active: clicked, collapsed: false }
  return { active, collapsed: !collapsed }
}
